var render = function render(){var _vm=this,_c=_vm._self._c;return _c('message',{attrs:{"t":_vm.t,"tc":_vm.tc[0]}},[_vm._v("\n    "+_vm._s(_vm.tc.length ? _vm.$tc(_vm.tc[0], _vm.tc[1], _vm.tc[2]) : _vm.$t(_vm.t))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }